export type ContactNumbers = {
  phoneNumber: string;
  whatsappNumber: string;
};

export const DEFAULT_CONTACT_NUMBERS_LOS: ContactNumbers = {
  phoneNumber: '+918071174410',
  whatsappNumber: '+918105574747',
} as const;

export const DEFAULT_CONTACT_NUMBERS_LMS: ContactNumbers = {
  phoneNumber: '+917949106901',
  whatsappNumber: '+918105574747',
} as const;

